import Vue from 'vue'

class PaymentOnboardingRepository {

  // ============================================
  // Back-office API (authenticated, OPERATOR_WRITE)
  // ============================================

  // GET /api/payment/onboarding/enrollments
  listEnrollments(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/search`,
        method: 'post',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // GET /api/payment/onboarding/enrollments/{id}
  getEnrollmentById(enrollmentId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/${enrollmentId}`,
        method: 'get'
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/payment/onboarding/enrollments
  createEnrollment({ type, email, companyName, firstName, lastName, accountNumber, evcoId, siret, vatNumber, phone, locale, address, attachToOrganization, memberType, memberGroups } = {}) {
    return new Promise((resolve, reject) => {
      const data = { email, companyName }
      if (type) data.type = type
      if (firstName) data.firstName = firstName
      if (lastName) data.lastName = lastName
      if (accountNumber) data.accountNumber = accountNumber
      if (evcoId) data.evcoId = evcoId
      if (siret) data.siret = siret
      if (vatNumber) data.vatNumber = vatNumber
      if (phone) data.phone = phone
      if (locale) data.locale = locale
      if (address) data.address = address
      if (attachToOrganization) data.attachToOrganization = attachToOrganization
      if (memberType) data.memberType = memberType
      if (memberGroups) data.memberGroups = memberGroups

      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments`,
        method: 'post',
        data
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/payment/onboarding/enrollments/{id}/send
  sendEnrollmentEmail(enrollmentId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/${enrollmentId}/send`,
        method: 'post'
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/payment/onboarding/enrollments/{id}/renew-token
  renewEnrollmentToken(enrollmentId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/${enrollmentId}/renew-token`,
        method: 'post'
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/payment/onboarding/enrollments/{id}/convert
  convertToOrganization(enrollmentId, { parentId } = {}) {
    return new Promise((resolve, reject) => {
      const data = {
        parentId
      }

      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/${enrollmentId}/convert`,
        method: 'post',
        data
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/payment/onboarding/enrollments/{id}/convert-to-customer
  convertToCustomer(enrollmentId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/${enrollmentId}/convert-to-customer`,
        method: 'post',
        data: {}
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/payment/onboarding/enrollments/{id}/attach
  attachToOrganization(enrollmentId, { organizationId, customerId } = {}) {
    return new Promise((resolve, reject) => {
      const data = {}
      if (organizationId) data.organizationId = organizationId
      if (customerId) data.customerId = customerId

      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/${enrollmentId}/attach`,
        method: 'post',
        data
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // PUT /api/payment/onboarding/enrollments/{id}
  updateEnrollment(enrollmentId, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/${enrollmentId}`,
        method: 'put',
        data
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // DELETE /api/payment/onboarding/enrollments/{id}
  deleteEnrollment(enrollmentId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/${enrollmentId}`,
        method: 'delete'
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/payment/onboarding/enrollments/{id}/cancel
  cancelEnrollment(enrollmentId, { reason } = {}) {
    return new Promise((resolve, reject) => {
      const data = {}
      if (reason) data.reason = reason

      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/${enrollmentId}/cancel`,
        method: 'post',
        data
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // GET /api/payment/onboarding/enrollments/template
  getEnrollmentTemplate() {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/enrollments/template`,
        method: 'get'
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/payment/onboarding/batches/import
  importCsv(file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('file', file)

      Vue.auth.fetch({
        url: `/api/payment/onboarding/batches/import`,
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/payment/onboarding/batches/{batchId}/confirm
  confirmBatch(batchId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/batches/${batchId}/confirm`,
        method: 'post'
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // GET /api/payment/onboarding/mandates/{snapshotId}/view
  getSignedMandateView(snapshotId, { locale = 'fr' } = {}) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/payment/onboarding/mandates/${snapshotId}/view`,
        method: 'get',
        data: { locale }
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // ============================================
  // Public API (token-based, no session)
  // ============================================

  // GET /api/onboarding/enrollments
  // Headers: Authorization: Bearer {token}
  getEnrollmentByToken(token) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/onboarding/enrollments`,
        method: 'get',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        _noToken: true
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/onboarding/enrollments/validate
  // Headers: Authorization: Bearer {token}
  validateEnrollment(token, { companyName, firstName, lastName, email, accountNumber, evcoId, siret, vatNumber, phone, address, memberType, memberGroups } = {}) {
    return new Promise((resolve, reject) => {
      const data = { companyName }
      if (firstName) data.firstName = firstName
      if (lastName) data.lastName = lastName
      if (email) data.email = email
      if (accountNumber) data.accountNumber = accountNumber
      if (evcoId) data.evcoId = evcoId
      if (siret) data.siret = siret
      if (vatNumber) data.vatNumber = vatNumber
      if (phone) data.phone = phone
      if (address) data.address = address
      if (memberType) data.memberType = memberType
      if (memberGroups) data.memberGroups = memberGroups

      Vue.auth.fetch({
        url: `/api/onboarding/enrollments/validate`,
        method: 'post',
        data,
        headers: {
          'Authorization': `Bearer ${token}`
        },
        _noToken: true
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/onboarding/mandates/preview
  // Headers: Authorization: Bearer {token}
  previewMandate(token, { stripePaymentMethodId, signatoryFirstName, signatoryLastName, locale = 'fr' }) {
    return new Promise((resolve, reject) => {
      const data = {
        stripePaymentMethodId,
        locale
      }
      if (signatoryFirstName) data.signatoryFirstName = signatoryFirstName
      if (signatoryLastName) data.signatoryLastName = signatoryLastName

      Vue.auth.fetch({
        url: `/api/onboarding/mandates/preview`,
        method: 'post',
        data,
        headers: {
          'Authorization': `Bearer ${token}`
        },
        _noToken: true
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/onboarding/enrollments/confirm
  // Headers: Authorization: Bearer {token}
  confirmEnrollment(token, { stripePaymentMethodId, contentHash, snapshotData }) {
    return new Promise((resolve, reject) => {
      const data = {
        stripePaymentMethodId,
        contentHash,
        snapshotData
      }

      Vue.auth.fetch({
        url: `/api/onboarding/enrollments/confirm`,
        method: 'post',
        data,
        headers: {
          'Authorization': `Bearer ${token}`
        },
        _noToken: true
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/onboarding/enrollments/visit
  // Headers: Authorization: Bearer {token}
  markEnrollmentVisited(token) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/onboarding/enrollments/visit`,
        method: 'post',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        _noToken: true
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }

  // POST /api/onboarding/enrollments/setup-intent
  // Headers: Authorization: Bearer {token}
  createSetupIntent(token, { paymentMethodType = 'sepa_debit' } = {}) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/onboarding/enrollments/setup-intent`,
        method: 'post',
        data: { paymentMethodType },
        headers: {
          'Authorization': `Bearer ${token}`
        },
        _noToken: true
      }).then(response => {
        resolve(response.data)
      }).catch(err => reject(err))
    })
  }
}

export default new PaymentOnboardingRepository()
